// import React from 'react';
// import { motion } from 'framer-motion'; // ✅ import motion
// import img1 from '../assets/images/companies/GOVT.svg';
// import img2 from '../assets/images/companies/manthar.jpg';
// import img3 from '../assets/images/companies/college_choice_101.svg';
// import img4 from '../assets/images/companies/sanaidee.svg';
// import img5 from '../assets/images/companies/slove.svg';
// import img6 from '../assets/images/companies/islam360.svg';
// import img7 from '../assets/images/companies/tcs.svg';
// import img8 from '../assets/images/companies/karzone.svg';




// const container = {
//   hidden: {},
//   visible: {
//     transition: {
//       staggerChildren: 0.2,
//     },
//   },
// };

// const fadeUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
// };

// const ClientsSection = () => {
//   return (
//     <motion.div
//       className="flex flex-col items-center justify-center p-5 sm:p-10 max-w-7xl mx-auto gap-y-10 text-center mt-10"
//       initial="hidden"
//       whileInView="visible"
//       viewport={{ once: true }}
//       variants={container}
//     >
//       <motion.div variants={fadeUp}>
//         <h1 className="font-extrabold text-2xl sm:text-4xl text-gray-700">
//           Trusted by Global Enterprises
//         </h1>
//         <p className="font-semibold text-xl sm:text-2xl mt-2 text-gray-700">
//           At Infoneo we support our customers through agile deliveries and more simplified solutions.
//         </p>
//       </motion.div>

//       <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-8 gap-2 sm:gap-x-2">
//         {[img1, img2, img3, img4, img5, img6,img7,img8].map((img, idx) => (
//           <motion.div
//             key={idx}
//             className="border rounded lg border-gray-200 p-2"
//             variants={fadeUp}
//             whileHover={{ scale: 1.05 }}
//           >
//             <img src={img} alt={`client-${idx}`} />
//           </motion.div>
//         ))}
//       </div>
//     </motion.div>
//   );
// };

// export default ClientsSection;



import React from 'react';
import { motion } from 'framer-motion';
import Slider from 'react-slick';

import img1 from '../assets/images/companies/GOVT.svg';
import img2 from '../assets/images/companies/manthar.jpg';
import img3 from '../assets/images/companies/college_choice_101.svg';
import img4 from '../assets/images/companies/sanaidee.svg';
import img5 from '../assets/images/companies/slove.svg';
import img6 from '../assets/images/companies/islam360.svg';
import img7 from '../assets/images/companies/tcs.svg';
import img8 from '../assets/images/companies/karzone.svg';

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4, // Adjust for responsiveness
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1 },
    },
  ],
};

const ClientsSection = () => {
  const images = [img1, img2, img3, img4, img5, img6, img7, img8];

  return (
    <motion.div
      className="flex flex-col items-center justify-center p-5 sm:p-10 max-w-7xl mx-auto gap-y-10 text-center mt-10"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={container}
    >
      <motion.div variants={fadeUp}>
        <h1 className="font-extrabold text-2xl sm:text-4xl text-gray-700">
          Trusted by Global Enterprises
        </h1>
        <p className="font-semibold text-xl sm:text-2xl mt-2 text-gray-700">
          At Infoneo we support our customers through agile deliveries and more simplified solutions.
        </p>
      </motion.div>

      <motion.div
        variants={fadeUp}
        className="w-full px-4 sm:px-8 lg:px-16"
      >
       <Slider {...sliderSettings}>
  {images.map((img, idx) => (
    <div key={idx} className="px-4">
      <motion.div
        className="border rounded border-gray-200 flex items-center justify-center h-32 sm:h-40 md:h-48 lg:h-56 bg-white shadow-sm"
        whileHover={{ scale: 1.05 }}
      >
        <img
          src={img}
          alt={`client-${idx}`}
          className="max-h-full max-w-full object-contain"
        />
      </motion.div>
    </div>
  ))}
</Slider>

      </motion.div>
    </motion.div>
  );
};

export default ClientsSection;
